const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Slide out sidebar
 */
const SidebarSlide = {

    // 1. describe and create/initiate our object
    init() { 
        this.openButton = $('.filter__wrapper a');
        this.closeButton = $('.close-icon, .curtain');
        this.openMenu = $('.mobile-nav');
        this.warrantyLink = $('#menu-item-394 a');
        this.events();
    },

    // 2. events
    events() {
        this.openButton.on('click', this.openOverlay);
        this.closeButton.on('click', this.closeOverlay);
        this.openMenu.on('click', this.mobileMenu);
        this.warrantyLink.on('click', this.closeOverlay);
    },

    // 3. methods (function, action..)
    openOverlay() {
        $('body').addClass('sidebar-open');
    },

    closeOverlay() {
        $('body').removeClass('sidebar-open menu-open');
    },
    
    mobileMenu() {
        $('body').addClass('menu-open');
    }

};

export default SidebarSlide;